import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { themeCheck } from '@upr-gds-web/components';
import * as i4 from '@upr-web-primer/gds-input-helper';
import { gdsVisaCardValidator, gdsPasswordValidator, gdsEmailValidator, gdsNameValidator, GdsInputHelperDirective, GdsInputHelperModule } from '@upr-web-primer/gds-input-helper';
import { get, isArray } from 'lodash-es';
import { take, Subject } from 'rxjs';
import * as i3 from '@angular/forms';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i1 from '@upr-web-primer/page-labels';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
const _c0 = (a0, a1) => ({
  type: "primary",
  label: a0,
  disabled: a1
});
function GdsDynamicFormComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "gds-input", 3)(2, "gds-spacer", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const input_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", input_r1 == null ? null : input_r1.key)("data", input_r1)("hideSpinner", true)("errors", ctx_r1.formControls[input_r1.key] == null ? null : ctx_r1.formControls[input_r1.key].errors == null ? null : ctx_r1.formControls[input_r1.key].errors.message);
  }
}
class GdsDynamicFormService {
  constructor(pageLabelsResolver) {
    this.pageLabelsResolver = pageLabelsResolver;
    if (this.pageLabelsResolver) {
      this.pageLabelsResolver.$pageLabels.pipe(take(1)).subscribe(pageLabels => {
        this.pageLabels = pageLabels;
      });
    }
  }
  /**
   * Create a form group from an array of inputData.
   * @param inputData - GdsInputBase<string>[]
   * @returns A FormGroup
   */
  customFormGroup(inputData) {
    const group = {};
    inputData.forEach(inputItem => {
      switch (inputItem.type) {
        case 'text':
          group[inputItem.key] = new FormControl(inputItem.value || '', gdsNameValidator(this.pageLabels?.ER26, this.pageLabels?.ER26, this.pageLabels?.ER1));
          break;
        case 'email':
          group[inputItem.key] = new FormControl(inputItem.value || '', gdsEmailValidator(this.pageLabels?.ER26, this.pageLabels?.ER6));
          break;
        case 'password':
          group[inputItem.key] = new FormControl(inputItem.value || '', gdsPasswordValidator(this.pageLabels?.ER26, this.pageLabels?.ER9));
          break;
        case 'number':
          group[inputItem.key] = new FormControl(inputItem.value || '', gdsVisaCardValidator(this.pageLabels?.ER26, this.pageLabels?.ERR_VISA));
          break;
        default:
          group[inputItem.key] = new FormControl(inputItem.value || '');
          break;
      }
    });
    return new FormGroup(group);
  }
  static {
    this.ɵfac = function GdsDynamicFormService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsDynamicFormService)(i0.ɵɵinject(i1.PageLabelsResolver));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GdsDynamicFormService,
      factory: GdsDynamicFormService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsDynamicFormService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.PageLabelsResolver
  }], null);
})();
class GdsInputBase {
  constructor(options = {}) {
    this.value = options.value;
    this.primaryLabel = options.primaryLabel || '';
    this.secondaryText = options.secondaryText || '';
    this.primaryIconTitleText = options.primaryIconTitleText || '';
    this.secondaryIconTitleText = options.secondaryIconTitleText || '';
    this.type = options.type || '';
    this.key = options.key || this.type === 'password' ? this.type : 'formInput' + this.primaryLabel?.split(' ')[0];
    this.name = options.name || this.type === 'password' ? this.type : 'formInput' + this.primaryLabel?.split(' ')[0];
    this.altText = options.altText || '';
    this.ariaText = options.ariaText || '';
    this.required = !!options.required;
  }
}
class GdsDynamicFormComponent extends GdsInputHelperDirective {
  /**
   * The constructor is called when the component is created.
   * @param {ElementRef} elementRef - ElementRef - The element reference for the component.
   * @param {GdsDynamicFormService} gdfs - GdsDynamicFormService
   * @returns None
   */
  constructor(elementRef, gdfs) {
    super(elementRef);
    this.gdfs = gdfs;
    /**
     * An output property that is used to send the form
     * payload to the parent component.
     * @type EventEmitter<any>
     * @readonly
     */
    this.inputPayLoad = new Subject();
  }
  /**
   * This function creates a form group from the input data.
   * @returns None
   */
  ngOnInit() {
    this.pageLabels = this.gdfs.pageLabels || get(this.data, 'pageLabels');
    const inputs = new Array().concat(get(this.data, 'gdsInputs'));
    this.contrast = get(this.data, 'contrast');
    this.theme = themeCheck(get(this.data, 'theme', 'gds-default'));
    if (isArray(inputs) && inputs.length) {
      this.inputData = inputs.map(inputItem => {
        return new GdsInputBase(inputItem);
      });
      this.inputForm = this.gdfs.customFormGroup(this.inputData);
    }
  }
  /**
   * It returns the form controls of the form.
   * @returns The formControls property.
   */
  get formControls() {
    return this.inputForm?.controls;
  }
  /**
   * Returns true if the form is invalid.
   * @returns The value of the inputForm.invalid property.
   */
  get isInvalid() {
    return this.inputForm?.invalid ? 'true' : 'false';
  }
  onSubmit() {
    if (this.inputForm.valid) {
      this.inputPayLoad.next(this.inputForm.value);
      this.inputForm.reset();
    }
  }
  static {
    this.ɵfac = function GdsDynamicFormComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsDynamicFormComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(GdsDynamicFormService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GdsDynamicFormComponent,
      selectors: [["upr-gds-dynamic-form"]],
      inputs: {
        data: "data",
        contrast: "contrast",
        theme: "theme"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 3,
      vars: 6,
      consts: [[3, "formGroup"], [4, "ngFor", "ngForOf"], [3, "buttonClicked", "data"], [3, "formControlName", "data", "hideSpinner", "errors"], ["classes", "spacer-50"]],
      template: function GdsDynamicFormComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "form", 0);
          i0.ɵɵtemplate(1, GdsDynamicFormComponent_div_1_Template, 3, 4, "div", 1);
          i0.ɵɵelementStart(2, "gds-buttons", 2);
          i0.ɵɵlistener("buttonClicked", function GdsDynamicFormComponent_Template_gds_buttons_buttonClicked_2_listener() {
            return ctx.onSubmit();
          });
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.inputForm);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.inputData);
          i0.ɵɵadvance();
          i0.ɵɵproperty("data", i0.ɵɵpureFunction2(3, _c0, (ctx.pageLabels == null ? null : ctx.pageLabels.lblManageAccountRegister) || "Create Account", ctx.isInvalid));
        }
      },
      dependencies: [i2.NgForOf, i3.ɵNgNoValidate, i3.NgControlStatus, i3.NgControlStatusGroup, i3.FormGroupDirective, i3.FormControlName, i4.GdsInputHelperDirective],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsDynamicFormComponent, [{
    type: Component,
    args: [{
      selector: 'upr-gds-dynamic-form',
      standalone: false,
      template: "<form [formGroup]=\"inputForm\">\r\n\t<div *ngFor=\"let input of inputData\">\r\n\t\t<gds-input [formControlName]=\"input?.key\" [data]=\"input\" [hideSpinner]=\"true\"\r\n\t\t\t[errors]=\"formControls[input.key]?.errors?.message\"></gds-input>\r\n\t\t<gds-spacer classes=\"spacer-50\"></gds-spacer>\r\n\t</div>\r\n\t<gds-buttons [data]=\"{\r\n\t\t\ttype: 'primary',\r\n\t\t\tlabel: pageLabels?.lblManageAccountRegister || 'Create Account',\r\n\t\t\tdisabled: isInvalid\r\n\t\t}\" (buttonClicked)=\"onSubmit()\"></gds-buttons>\r\n</form>\r\n"
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: GdsDynamicFormService
  }], {
    data: [{
      type: Input
    }],
    contrast: [{
      type: Input
    }],
    theme: [{
      type: Input
    }]
  });
})();
class GdsDynamicFormModule {
  static {
    this.ɵfac = function GdsDynamicFormModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsDynamicFormModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GdsDynamicFormModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule, ReactiveFormsModule, GdsInputHelperModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsDynamicFormModule, [{
    type: NgModule,
    args: [{
      declarations: [GdsDynamicFormComponent],
      imports: [CommonModule, FormsModule, ReactiveFormsModule, GdsInputHelperModule],
      exports: [GdsDynamicFormComponent],
      schemas: [CUSTOM_ELEMENTS_SCHEMA]
    }]
  }], null, null);
})();

/*
 * Public API Surface of gds-dynamic-form
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GdsDynamicFormComponent, GdsDynamicFormModule, GdsDynamicFormService };
